<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
  >
    <div class="font-normal my-8">
      <div class="flex justify-center"><check-mark-icon /></div>
      <div class="text-xl mt-4 font-bold text-root-2 flex justify-center">
        Done
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'doneDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '20%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  }
}
</script>

<style scoped></style>
